import * as React from "react";
import { readPersisted, STOPWATCH_STORAGE_KEY } from "../services/stopwatchStorage";

const computeSeconds = (p: ReturnType<typeof readPersisted>) => {
  const runningDelta =
    p.isRunning && p.startedAt
      ? Math.floor((Date.now() - p.startedAt) / 1000)
      : 0;

  return p.sessionAccumulated + runningDelta;
};

export const useAccurateStopwatch = () => {
  const [seconds, setSeconds] = React.useState(0);

  const recalc = React.useCallback(() => {
    const p = readPersisted();
    setSeconds(computeSeconds(p));
  }, []);

  React.useEffect(() => {
    recalc();
  }, [recalc]);

  React.useEffect(() => {
    const id = setInterval(recalc, 1000);
    return () => clearInterval(id);
  }, [recalc]);

  React.useEffect(() => {
    const onFocus = recalc;
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [recalc]);

  React.useEffect(() => {
    const handler = (e: StorageEvent) => {
      if (e.key === STOPWATCH_STORAGE_KEY) recalc();
    };

    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, [recalc]);

  return { seconds, recalc };
};

